<template>
  <div class="text-center pt-4">
    <b-spinner class="mb-2" />
    <div>{{ text }}</div>
  </div>
</template>

<script>
export default {
  props: {
    text: { type: String, default: 'กำลังโหลด...' }
  }
}
</script>
